import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2388a1af"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-user-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_4 = {
  class: "pagination-box"
};
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { Search, Refresh } from '@element-plus/icons-vue';
import usePagination from '@/hooks/usePagination';
import { getClinicUserPage } from '@/api/tenant';
import { indexMethod } from '@/utils/indexMethod';
import ClinicUser from './components/ClinicUser';
import { getRoleList } from '@/api/role';
import { formSchemas } from './config';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const formSchemasRef = ref(formSchemas);
    const {
      clinicId
    } = route.params;
    const {
      tenantId
    } = route.query;
    formSchemasRef.value.find(item => item.field === 'tenantId').defaultValue = tenantId;
    formSchemasRef.value.find(item => item.field === 'lastLoginClinic').defaultValue = clinicId;
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const tableData = ref([]);
    const loading = ref(false);
    const keyword = ref('');
    const _getUserPageListByTenantId = async () => {
      loading.value = true;
      const res = await getClinicUserPage(clinicId, {
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        keyword: keyword.value
      });
      tableData.value = res.records;
      setTotal(res.total);
      loading.value = false;
    };
    _getUserPageListByTenantId();
    const roles = ref([]);
    const addRoleByTenant = async () => {
      const res = await getRoleList({
        tenantId
      });
      formSchemasRef.value.find(item => item.field === 'userRoleList').checkboxArr = res;
      roles.value = res;
    };
    addRoleByTenant();
    const handleCurrentChange = e => {
      setCurrentPage(e);
    };

    // 添加租户用户
    const isAddTenantUserShow = ref(false); // show or hide

    const currentTenantUser = ref(null);
    const addUserHandler = () => {
      isAddTenantUserShow.value = true;
    };
    const handleUpdateUser = row => {
      isAddTenantUserShow.value = true;
      currentTenantUser.value = row;
    };
    const clearModel = () => {
      currentTenantUser.value = null;
    };
    const handleRefresh = async () => {
      setCurrentPage(1);
      keyword.value = '';
      _getUserPageListByTenantId();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入关键字",
          style: {
            "width": "300px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: _getUserPageListByTenantId
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addUserHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: tableData.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "#",
            type: "index",
            index: index => _unref(indexMethod)(index, _unref(currentPage), _unref(pageSize))
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            label: "账号",
            prop: "username"
          }), _createVNode(_component_el_table_column, {
            label: "创建时间"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", null, _toDisplayString(_ctx.$filters.dateFilter(row.createTime)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "账号状态"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_tag, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.statusName), 1)]),
              _: 2
            }, 1024)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              onClick: $event => handleUpdateUser(row),
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(ClinicUser), {
        modelValue: isAddTenantUserShow.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isAddTenantUserShow.value = $event),
        clinicId: _unref(clinicId),
        onClearModel: clearModel,
        model: currentTenantUser.value,
        onRefreshData: _getUserPageListByTenantId,
        tenantId: _unref(tenantId),
        roles: roles.value,
        formSchemas: formSchemasRef.value
      }, null, 8, ["modelValue", "clinicId", "model", "tenantId", "roles", "formSchemas"])]);
    };
  }
};